import {RouterView} from '../RouterView.js';
import Catalogs from '../../components/views/administration/settings/catalogs/Index'

export default {

    path:'/administracion/catalogos',
    component: RouterView,
    children: [
        {
            path: '',
            component: Catalogs,
            meta: {
                auth: true,
            }
        },

    ]
}
